const routes = {
    home: {
        route: "/",
        anchors: {
            root: "home",
            gameInfo: "gameinfo",
            nextGen: "nextgen",
            buy: "buy",
            media: "media",
        },
    },
    news: {
        route: "/news",
    },
    credits: { route: "/credits" },
};

export default routes;
